// Centralized CMM (form) IDs for BizChat scenarios
// Add new scenario-specific constants here instead of hard-coding strings.

// Compose DAB SUAs - New Email
export const COMPOSE_NEW_HELP_WRITE_CMM_ID: string = 'cmmb6qybd09';
export const COMPOSE_NEW_FIND_RECIPIENTS_CMM_ID: string = 'cmmzuvialef';
export const COMPOSE_NEW_SUPPORT_STATEMENT_CMM_ID: string = 'cmmayptquqv';

// Compose DAB SUAs - Reply
export const SUA_REPLY_EXPERIMENT_CMM_ID: string = 'cmm75g7vyyt';
export const COMPOSE_REPLY_HELP_REPLY_CMM_ID: string = 'cmmebtrbnlk';
export const COMPOSE_REPLY_NEXT_STEPS_CMM_ID: string = 'cmm9rps6dcf';
export const COMPOSE_REPLY_KEY_POINTS_CMM_ID: string = 'cmmfkjrtdp0';

// Compose DAB SUAs - Forward
export const COMPOSE_FORWARD_EXPLAIN_CMM_ID: string = 'cmmbm7azaru';
export const COMPOSE_FORWARD_WITH_CONTEXT_CMM_ID: string = 'cmmlbf7ged0';
export const COMPOSE_FORWARD_WITH_TASKS_CMM_ID: string = 'cmm82v7r21q';

export const IMMERSIVE_SEARCH_CMM_ID: string = 'cmmagwikx7a';
export const SEARCH_SUGGESTIONS_ZEROQUERY_CMM_ID: string = 'cmm847v5ypw';
export const SEARCH_SUGGESTIONS_QUERYFORMULATION_CMM_ID: string = 'cmmr8vd788b';
export const SUMMARIZE_IN_BIZCHAT_CMM_ID: string = 'cmm151dtrrj';
export const NOTIFICATIONS_SUMMARIZE_CMM_ID: string = 'cmm37ofay86';
export const ASK_COPILOT_CMM_ID: string = 'cmmc0ir0x64';
export const INSIGHTS_CMM_ID: string = 'cmmgd9favq8';
export const COPILOT_SEARCH_ANSWER_CMM_ID: string = 'cmmxaghlp5l';
export const COMPOSE_SUGGESTED_DRAFTS_CMM_ID: string = 'cmmpj6c0bne';

/**
 * CMM ID for Calendar Immersive Search scenario.
 * Note: This value is duplicated in @outlook/calendar-text-prompts (shared/nova/calendar-text-prompts)
 * due to package isolation constraints. Keep both values in sync.
 */
export const CALENDAR_IMMERSIVE_SEARCH_CMM_ID: string = 'cmm6dymueiy';
export const CALENDAR_MEETING_HELP_ME_PREP_CMM_ID: string = 'cmmlaqq6pcx';
export const CALENDAR_INSTRUCTIONS_ACTIONS_AGENT_BAR_CMM_ID: string = 'cmmbuv6hz0j';
export const CALENDAR_INSTRUCTIONS_ACTIONS_COMMAND_CENTER_CMM_ID: string = 'cmmnuszr5mh';
export const CALENDAR_INSTRUCTIONS_ACTIONS_PRIMARY_CMM_ID: string = 'cmmbm8ohwah';
export const CALENDAR_INSTRUCTIONS_ACTIVITIES_SETTINGS_CMM_ID: string = 'cmmbxdghsq4';
export const CALENDAR_INSTRUCTIONS_CREATE_CMM_ID: string = 'cmmzbgobp81';
export const CALENDAR_INSTRUCTIONS_CREATE_SURFACE_ITEM_CMM_ID: string = 'cmmuzd535im';
export const CALENDAR_INSTRUCTIONS_ACTIVITIES_DELETE_FRE_CMM_ID: string = 'cmmwtssir2n';
export const CALENDAR_INSTRUCTIONS_CREATE_DELETE_FRE_CMM_ID: string = 'cmmz2d4s9vq';
export const CALENDAR_INSTRUCTIONS_DELETE_CANCELED_ACCEPT_FRE_CMM_ID: string = 'cmm4o76y4u5';
export const CALENDAR_INSTRUCTIONS_CREATE_ACCEPT_FRE_CMM_ID: string = 'cmmfl2azi95';
export const CALENDAR_INSTRUCTIONS_NEEDS_ATTENTION_CMM_ID: string = 'cmmi3ec0b43';
export const CALENDAR_INSTRUCTIONS_VIEW_INSTRUCTIONS_CMM_ID: string = 'cmm5b3f2pw4';
export const START_CHAT_DRAFT_CMM_ID: string = 'cmmeiat63t6';
export const DRAFT_ASSISTANT_CMM_ID: string = 'cmmyz8p6paw';
export const DRAFT_ASSISTANT_REPLY_FORWARD_CMM_ID: string = 'cmmq2silgi7';
export const DRAFT_ASSISTANT_HIGHLIGHT_REWRITE_CMM_ID: string = 'cmm27cix7dh';
export const CALENDAR_DRAFT_ASSISTANT_CMM_ID: string = 'cmmsydqyyio';
export const UNIFIED_MEETING_ASSISTANT_CMM_ID: string = 'cmmp0zg5aes';
export const CALENDAR_SCHEDULE_FROM_EMAIL_CMM_ID: string = 'cmm6vifevnf';
export const CALENDAR_TRY_TOP_PRIORITIES_CMM_ID: string = 'cmmeek7bcwh';
export const COPILOT_COMMAND_CENTER_COACH_CMM_ID: string = 'cmmg2ctd5x6';
export const COPILOT_DAB_RIBBON_MAIN_BUTTON_CMM_ID: string = 'cmmxliu1q2y';
export const CLASSIC_ATTACHMENT_SUMMARY_CMM_ID: string = 'cmmaii3bpr3';
export const LINKED_ATTACHMENT_SUMMARY_CMM_ID: string = 'cmmoewnwc3d';
export const CATCH_UP_CMM_ID: string = 'cmmu40lh22u';
export const WRAP_UP_CMM_ID: string = 'cmmchpv189d';

export const AGENT_NEEDS_ATTENTION_HANDWAVE_CMM_ID: string = 'cmm8gp27f30';
export const AGENT_BAR_CREATE_INSTRUCTION_PROMPT_CMM_ID: string = 'cmmis3tnfzm';
export const AGENT_BAR_LIST_INSTRUCTIONS_PROMPT_CMM_ID: string = 'cmmbqs7jjzo';

export const CALENDAR_M365FRE_PREPARE_FOR_NEXT_MEETING_CMM_ID: string = 'cmma5b96m1a';
export const CALENDAR_M365FRE_RECAP_FOR_LATEST_MEETINGS_CMM_ID: string = 'cmmrrjv1utk';
export const CALENDAR_M365FRE_SCHEDULE_FOCUS_TIME_NEXT_WEEK_CMM_ID: string = 'cmmaa4fayyn';

// Mail DAB SUAs
export const FIND_QUICK_WINS_CMM_ID: string = 'cmms7bt06i3';
export const GET_ORIENTED_CMM_ID: string = 'cmmmljyih87';
export const SUGGEST_NEXT_STEPS_CMM_ID: string = 'cmmnga5qm2r';
export const SUMMARIZE_CMM_ID: string = 'cmmemdb07yk';
export const SUMMARIZE_AND_REPLY_CMM_ID: string = 'cmm9uaofbq8';
export const TRIAGE_MY_INBOX_CMM_ID: string = 'cmm2syst0oj';

// Mail Reading Pane Proactive SUA
export const PROACTIVE_SHOW_KEY_TAKEAWAYS_CMM_ID: string = 'cmmnaejze13';

// Proactive Summary card SUAs (both Sydney-generated and default hardcoded)
export const PROACTIVE_SUMMARY_SUA_CMM_ID: string = 'cmm1cdgq7na';
